import { module } from 'angular';
import { baseModuleId } from '../common/constants/base-module-id';
import { ProductKeySellingPointsDirective } from './product-key-selling-points.directive';
export var ProductKeySellingPointsComponentNgModule = module(baseModuleId + ".product-key-selling-points", [])
    .directive('productKeySellingPoints', ProductKeySellingPointsDirective);
